module.exports = __webpack_public_path__ + "img/raw.2b64d79d.png";